// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommentFeedFragmentDoc, CommentCurrentUserFragmentDoc } from '../../../components/comments/CommentFeed.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { ScopeHistoryDetailsFragmentDoc, ProjectItemUnitOfMeasureFragmentDoc } from './SelectionsSharedFragments.generated';
import { FollowerFragmentDoc } from '../../../components/Followers.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DeleteProjectItemMutationVariables = Types.Exact<{
  input: Types.DeleteProjectItemInput;
}>;


export type DeleteProjectItemMutation = { __typename?: 'Mutation', deleteProjectItem: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type SpecTabQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type SpecTabQuery = { __typename?: 'Query', currentInternalUser?: { __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string } | null | undefined, projectItem: { __typename?: 'ProjectItem', id: string, name: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, buyoutStatus: Types.BuyoutStatus, costType: Types.CostType, totalCostInCents: number, totalPriceInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, supportedVisibilities: Array<Types.CommentStreamVisibility>, costConfidence: { __typename?: 'CostConfidenceDetail', code: Types.CostConfidence }, canEditCostConfidence: { __typename?: 'PotentialOperation2', allowed: boolean }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, sageName?: string | null | undefined, useQuantity: boolean }, scopeHistory: Array<{ __typename?: 'ProjectItemScopeChange', costInCents: number, priceInCents: number, quantity?: number | null | undefined, tradePartnerNote?: string | null | undefined, specifications?: string | null | undefined, shortName: string }>, location: { __typename?: 'Location', id: string, name: string }, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, canEditProjectItemsDirectly: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage }, status: { __typename?: 'ProjectStageStatusDetail', code: Types.ProjectStageStatus, name: string }, project:
        | { __typename?: 'StandaloneProject', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Region', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Market', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Community', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Subdivision', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Lot', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Structure', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
        | { __typename?: 'Unit', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
       }, item: { __typename?: 'Item', id: string, name: string, itemCode: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> }, locations: Array<{ __typename?: 'Location', id: string, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }>, costConfidences: Array<{ __typename?: 'CostConfidenceDetail', code: Types.CostConfidence, name: string }> };

export type SaveProjectItemDetailsMutationVariables = Types.Exact<{
  input: Types.ProjectItemInput;
}>;


export type SaveProjectItemDetailsMutation = { __typename?: 'Mutation', saveProjectItems: { __typename?: 'SaveProjectItemsResult', projectItems?: Array<{ __typename?: 'ProjectItem', id: string, name: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, buyoutStatus: Types.BuyoutStatus, costType: Types.CostType, totalCostInCents: number, totalPriceInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, supportedVisibilities: Array<Types.CommentStreamVisibility>, costConfidence: { __typename?: 'CostConfidenceDetail', code: Types.CostConfidence }, canEditCostConfidence: { __typename?: 'PotentialOperation2', allowed: boolean }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, sageName?: string | null | undefined, useQuantity: boolean }, scopeHistory: Array<{ __typename?: 'ProjectItemScopeChange', costInCents: number, priceInCents: number, quantity?: number | null | undefined, tradePartnerNote?: string | null | undefined, specifications?: string | null | undefined, shortName: string }>, location: { __typename?: 'Location', id: string, name: string }, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, canEditProjectItemsDirectly: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage }, status: { __typename?: 'ProjectStageStatusDetail', code: Types.ProjectStageStatus, name: string }, project:
          | { __typename?: 'StandaloneProject', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Region', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Market', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Community', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Subdivision', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Lot', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Structure', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
          | { __typename?: 'Unit', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
         }, item: { __typename?: 'Item', id: string, name: string, itemCode: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> }> | null | undefined, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null | undefined } };

export type ProjectItemDetailsPageDetailsFragment = { __typename?: 'ProjectItem', id: string, name: string, displayName: string, quantity?: number | null | undefined, unitCostInCents: number, buyoutStatus: Types.BuyoutStatus, costType: Types.CostType, totalCostInCents: number, totalPriceInCents: number, specifications?: string | null | undefined, tradePartnerNote?: string | null | undefined, internalNote?: string | null | undefined, supportedVisibilities: Array<Types.CommentStreamVisibility>, costConfidence: { __typename?: 'CostConfidenceDetail', code: Types.CostConfidence }, canEditCostConfidence: { __typename?: 'PotentialOperation2', allowed: boolean }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, sageName?: string | null | undefined, useQuantity: boolean }, scopeHistory: Array<{ __typename?: 'ProjectItemScopeChange', costInCents: number, priceInCents: number, quantity?: number | null | undefined, tradePartnerNote?: string | null | undefined, specifications?: string | null | undefined, shortName: string }>, location: { __typename?: 'Location', id: string, name: string }, projectStage: { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, canEditProjectItemsDirectly: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage }, status: { __typename?: 'ProjectStageStatusDetail', code: Types.ProjectStageStatus, name: string }, project:
      | { __typename?: 'StandaloneProject', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Region', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Market', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Community', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Subdivision', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Lot', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Structure', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
      | { __typename?: 'Unit', id: string, availableAssignees: Array<{ __typename?: 'InternalUser', id: string, name: string }> }
     }, item: { __typename?: 'Item', id: string, name: string, itemCode: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined }, followers: Array<{ __typename?: 'InternalUser', id: string, name: string, avatar: string, email: string }>, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number, streamVisibility: { __typename?: 'CommentStreamVisibilityDetail', code: Types.CommentStreamVisibility }, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, name: string, tradePartner: { __typename?: 'TradePartner', id: string } }>, comments: Array<{ __typename?: 'Comment', id: string, text: string, html: string, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], author: { __typename?: 'User', id: string, avatarUrl: string, name: string, type: Types.UserType, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, tags: Array<{ __typename?: 'CommentTag', id: string, internalUser: { __typename?: 'InternalUser', id: string } }> }> }> };

export type ProjectItemDetailsPageItemFragment = { __typename?: 'Item', id: string, name: string, itemCode: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, displayName: string } }, tradeCategory?: { __typename?: 'TradeCategory', id: string, name: string } | null | undefined };

export type ProjectItemDetailsPageChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', id: string, quantity?: number | null | undefined, totalCostInCents: number, totalPriceInCents: number, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }, changeEvent: { __typename?: 'ChangeEvent', id: string, identifier: number } };

export type CeliUnitOfMeasureFragment = { __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean };

export const ProjectItemDetailsPageItemFragmentDoc = gql`
    fragment ProjectItemDetailsPageItem on Item {
  id
  name
  itemCode
  costCode {
    id
    displayName
    division {
      id
      displayName
    }
  }
  tradeCategory {
    id
    name
  }
}
    `;
export const ProjectItemDetailsPageDetailsFragmentDoc = gql`
    fragment ProjectItemDetailsPageDetails on ProjectItem {
  id
  ...CommentFeed
  name
  displayName
  quantity
  unitCostInCents
  buyoutStatus
  costType
  totalCostInCents
  totalPriceInCents
  specifications
  tradePartnerNote
  internalNote
  costConfidence {
    code
  }
  canEditCostConfidence {
    allowed
  }
  unitOfMeasure {
    id
    name
    sageName
    useQuantity
  }
  scopeHistory {
    ...ScopeHistoryDetails
  }
  location {
    ...Named
  }
  projectStage {
    id
    hasSignedContract
    canEditProjectItemsDirectly
    stage {
      code
    }
    status {
      code
      name
    }
    project {
      id
      availableAssignees {
        ...Follower
      }
    }
  }
  item {
    ...ProjectItemDetailsPageItem
  }
}
    ${CommentFeedFragmentDoc}
${ScopeHistoryDetailsFragmentDoc}
${NamedFragmentDoc}
${FollowerFragmentDoc}
${ProjectItemDetailsPageItemFragmentDoc}`;
export const CeliUnitOfMeasureFragmentDoc = gql`
    fragment CeliUnitOfMeasure on UnitOfMeasure {
  id
  name
  useQuantity
}
    `;
export const ProjectItemDetailsPageChangeEventLineItemFragmentDoc = gql`
    fragment ProjectItemDetailsPageChangeEventLineItem on ChangeEventLineItem {
  id
  quantity
  totalCostInCents
  totalPriceInCents
  unitOfMeasure {
    ...CeliUnitOfMeasure
  }
  changeEvent {
    id
    identifier
  }
}
    ${CeliUnitOfMeasureFragmentDoc}`;
export const DeleteProjectItemDocument = gql`
    mutation DeleteProjectItem($input: DeleteProjectItemInput!) {
  deleteProjectItem(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteProjectItemMutation__
 *
 * To run a mutation, you first call `useDeleteProjectItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectItemMutation, { data, loading, error }] = useDeleteProjectItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProjectItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectItemMutation, DeleteProjectItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectItemMutation, DeleteProjectItemMutationVariables>(DeleteProjectItemDocument, options);
      }
export type DeleteProjectItemMutationHookResult = ReturnType<typeof useDeleteProjectItemMutation>;
export type DeleteProjectItemMutationResult = ApolloReactCommon.MutationResult<DeleteProjectItemMutation>;
export const SpecTabDocument = gql`
    query SpecTab($projectItemId: ID!) {
  currentInternalUser {
    ...CommentCurrentUser
  }
  projectItem(id: $projectItemId) {
    ...ProjectItemDetailsPageDetails
  }
  locations {
    ...Named
  }
  unitsOfMeasure {
    ...ProjectItemUnitOfMeasure
  }
  costConfidences {
    code
    name
  }
}
    ${CommentCurrentUserFragmentDoc}
${ProjectItemDetailsPageDetailsFragmentDoc}
${NamedFragmentDoc}
${ProjectItemUnitOfMeasureFragmentDoc}`;

/**
 * __useSpecTabQuery__
 *
 * To run a query within a React component, call `useSpecTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecTabQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useSpecTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SpecTabQuery, SpecTabQueryVariables> & ({ variables: SpecTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SpecTabQuery, SpecTabQueryVariables>(SpecTabDocument, options);
      }
export function useSpecTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SpecTabQuery, SpecTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SpecTabQuery, SpecTabQueryVariables>(SpecTabDocument, options);
        }
// @ts-ignore
export function useSpecTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SpecTabQuery, SpecTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SpecTabQuery, SpecTabQueryVariables>;
export function useSpecTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SpecTabQuery, SpecTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SpecTabQuery | undefined, SpecTabQueryVariables>;
export function useSpecTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SpecTabQuery, SpecTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SpecTabQuery, SpecTabQueryVariables>(SpecTabDocument, options);
        }
export type SpecTabQueryHookResult = ReturnType<typeof useSpecTabQuery>;
export type SpecTabLazyQueryHookResult = ReturnType<typeof useSpecTabLazyQuery>;
export type SpecTabSuspenseQueryHookResult = ReturnType<typeof useSpecTabSuspenseQuery>;
export type SpecTabQueryResult = ApolloReactCommon.QueryResult<SpecTabQuery, SpecTabQueryVariables>;
export const SaveProjectItemDetailsDocument = gql`
    mutation SaveProjectItemDetails($input: ProjectItemInput!) {
  saveProjectItems(input: {projectItems: [$input]}) {
    projectItems {
      ...ProjectItemDetailsPageDetails
    }
    userErrors {
      message
    }
  }
}
    ${ProjectItemDetailsPageDetailsFragmentDoc}`;

/**
 * __useSaveProjectItemDetailsMutation__
 *
 * To run a mutation, you first call `useSaveProjectItemDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectItemDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectItemDetailsMutation, { data, loading, error }] = useSaveProjectItemDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectItemDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectItemDetailsMutation, SaveProjectItemDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectItemDetailsMutation, SaveProjectItemDetailsMutationVariables>(SaveProjectItemDetailsDocument, options);
      }
export type SaveProjectItemDetailsMutationHookResult = ReturnType<typeof useSaveProjectItemDetailsMutation>;
export type SaveProjectItemDetailsMutationResult = ApolloReactCommon.MutationResult<SaveProjectItemDetailsMutation>;